/* ====================================================================
   QUEEN LENGTH V2 — fast-CTA layout JS
   - Qty stepper (+/- buttons) synced between main and sticky
   - Shade drawer toggle (collapsed by default)
   - Shade picker → updates hidden variant ID + hero image + price
   - Sticky bar visibility via IntersectionObserver
   - Sticky bar CTA delegates to real form submit
   - Cart drawer opens after add-to-cart
   ==================================================================== */

(function () {
  'use strict';

  function formatMoney(cents, symbol) {
    var s = symbol || '$';
    var num = Math.round(cents) / 100;
    var amount = num % 1 === 0 ? num.toString() : num.toFixed(2);
    return s + amount;
  }

  function init(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-ql-section]');
    sections.forEach(initSection);
  }

  function initSection(section) {
    if (section.dataset.qlInit === '1') return;
    section.dataset.qlInit = '1';

    var currencySymbol = section.dataset.qlCurrency || '$';
    var unitMode = section.dataset.qlUnitMode || 'packs';
    var gramsPerPack = parseInt(section.dataset.qlGrams || '90', 10);

    var state = {
      unitCents: parseInt(section.dataset.qlBasePrice || '0', 10),
      qty: 1,
      shadeName: ''
    };

    // ----- Cache nodes
    var qtyInput = section.querySelector('[data-ql-qty]');
    var variantInput = section.querySelector('[data-ql-variant-id]');
    var totalEls = section.querySelectorAll('[data-ql-total]');
    var unitEls = section.querySelectorAll('[data-ql-unit]');
    var heroImg = section.querySelector('[data-ql-hero]');
    var shadeNameEls = section.querySelectorAll('[data-ql-shade-name]');
    var selectedNameEl = section.querySelector('[data-qlv2-selected-name]');
    var stickybar = section.querySelector('[data-ql-stickybar]');
    var mainCta = section.querySelector('[data-ql-main-cta]');
    var stickyCta = section.querySelector('[data-ql-sticky-cta]');
    var tierChips = section.querySelectorAll('[data-ql-tier]');

    // Stepper elements (main)
    var minusBtn = section.querySelector('[data-ql-qty-minus]');
    var plusBtn = section.querySelector('[data-ql-qty-plus]');
    var qtyDisplay = section.querySelector('[data-ql-qty-display]');

    // Stepper elements (sticky)
    var stickyMinusBtn = section.querySelector('[data-ql-sticky-minus]');
    var stickyPlusBtn = section.querySelector('[data-ql-sticky-plus]');
    var stickyQtyDisplay = section.querySelector('[data-ql-sticky-qty-display]');
    var stickyPrice = section.querySelector('[data-ql-sticky-price]');

    // Shade section


    // ----- Render all dynamic elements
    function render() {
      var totalCents = state.unitCents * state.qty;
      var totalStr = formatMoney(totalCents, currencySymbol);
      var unitStr = formatMoney(state.unitCents, currencySymbol);

      totalEls.forEach(function (el) { el.textContent = totalStr; });
      unitEls.forEach(function (el) { el.textContent = unitStr; });

      // Qty displays (support both input and span)
      if (qtyDisplay) {
        if (qtyDisplay.tagName === 'INPUT') qtyDisplay.value = state.qty;
        else qtyDisplay.textContent = state.qty;
      }
      if (stickyQtyDisplay) {
        if (stickyQtyDisplay.tagName === 'INPUT') stickyQtyDisplay.value = state.qty;
        else stickyQtyDisplay.textContent = state.qty;
      }

      // Sticky price = total
      if (stickyPrice) stickyPrice.textContent = totalStr;

      // Qty input
      if (qtyInput) qtyInput.value = state.qty;

      // Tier chips
      tierChips.forEach(function (chip) {
        var tier = parseInt(chip.getAttribute('data-ql-tier'), 10);
        chip.classList.toggle('ql-tier--active', state.qty >= tier);
      });

      // Sticky shade name
      var stickyShadeEl = section.querySelector('[data-ql-sticky-shade]');
      if (stickyShadeEl && state.shadeName) stickyShadeEl.textContent = state.shadeName;
    }

    // ----- Qty stepper logic
    function changeQty(delta) {
      var newQty = state.qty + delta;
      if (newQty < 1) newQty = 1;
      if (newQty > 20) newQty = 20;
      state.qty = newQty;
      render();
    }

    if (minusBtn) minusBtn.addEventListener('click', function () { changeQty(-1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { changeQty(1); });
    if (stickyMinusBtn) stickyMinusBtn.addEventListener('click', function () { changeQty(-1); });
    if (stickyPlusBtn) stickyPlusBtn.addEventListener('click', function () { changeQty(1); });

    function setQtyFromInput(inp) {
      var n = parseInt(inp.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 20) n = 20;
      state.qty = n;
      render();
    }
    if (qtyDisplay && qtyDisplay.tagName === 'INPUT') {
      qtyDisplay.addEventListener('change', function () { setQtyFromInput(qtyDisplay); });
      qtyDisplay.addEventListener('blur', function () { setQtyFromInput(qtyDisplay); });
      qtyDisplay.addEventListener('input', function () {
        qtyDisplay.value = qtyDisplay.value.replace(/[^0-9]/g, '');
      });
    }
    if (stickyQtyDisplay && stickyQtyDisplay.tagName === 'INPUT') {
      stickyQtyDisplay.addEventListener('change', function () { setQtyFromInput(stickyQtyDisplay); });
      stickyQtyDisplay.addEventListener('blur', function () { setQtyFromInput(stickyQtyDisplay); });
      stickyQtyDisplay.addEventListener('input', function () {
        stickyQtyDisplay.value = stickyQtyDisplay.value.replace(/[^0-9]/g, '');
      });
    }




    // ----- Show all shades expander
    var showAllBtn = section.querySelector('[data-qlv2-show-all]');
    var mainGrid = section.querySelector('[data-qlv2-main-grid]');
    if (showAllBtn && mainGrid) {
      showAllBtn.addEventListener('click', function () {
        mainGrid.classList.remove('qlv2-shade-grid--capped');
        mainGrid.classList.add('qlv2-shade-grid--expanded');
        showAllBtn.hidden = true;
      });
    }

    // ----- Shade picker
    var shadeRadios = section.querySelectorAll('[data-ql-shade]');

    function applyShade(radio, skipImage) {
      if (!radio || !radio.checked) return;

      // Auto-expand group
      expandGroupForRadio(radio);

      // Update name
      var name = radio.getAttribute('data-shade-name') || radio.value;
      state.shadeName = name;
      shadeNameEls.forEach(function (el) { el.textContent = name; });
      if (selectedNameEl) selectedNameEl.textContent = name;

      // Update variant ID in hidden input
      if (variantInput) variantInput.value = radio.value;

      // Update price
      var newPrice = parseInt(radio.getAttribute('data-price-cents') || '', 10);
      if (!isNaN(newPrice) && newPrice > 0) {
        state.unitCents = newPrice;
      }
      render();

      // Swap hero image
      if (!skipImage) {
        var imgUrl = radio.getAttribute('data-shade-image');
        if (heroImg && imgUrl) {
          var s600 = radio.getAttribute('data-shade-image-600');
          var s900 = radio.getAttribute('data-shade-image-900');
          var s1200 = imgUrl;
          if (s600 && s900 && s1200) {
            heroImg.srcset = s600 + ' 600w, ' + s900 + ' 900w, ' + s1200 + ' 1200w';
          }
          heroImg.src = imgUrl;
        }
        // Scroll gallery to the slide containing the hero image
        var gallery = section.querySelector('.ql-gallery');
        if (gallery && heroImg) {
          var slide = heroImg.closest('.ql-gallery__slide');
          if (slide) {
            var slides = gallery.querySelectorAll('.ql-gallery__slide');
            var heroIndex = Array.prototype.indexOf.call(slides, slide);
            if (heroIndex >= 0) {
              gallery.scrollTo({ left: gallery.offsetWidth * heroIndex, behavior: 'smooth' });
              var dots = section.querySelectorAll('.ql-gallery__dot');
              dots.forEach(function (dot, i) {
                dot.classList.toggle('ql-gallery__dot--active', i === heroIndex);
              });
            }
          }
        }

        // Auto-scroll: hero → pause → back to selected shade confirmation
        var galleryEl = section.querySelector('.ql-buy__media');
        var selectedEl = section.querySelector('[data-qlv2-selected-name]');
        var scrollTarget = selectedEl ? selectedEl.closest('.qlv2-selected-shade') : section.querySelector('[data-ql-cta-wrap]');
        if (galleryEl && scrollTarget) {
          // Cancel any pending scroll-back
          if (window._qlv2ScrollBack) clearTimeout(window._qlv2ScrollBack);
          // Track if user manually scrolls (interrupt auto-return)
          var userScrolled = false;
          function onUserScroll() { userScrolled = true; }
          window.addEventListener('touchstart', onUserScroll, { once: true, passive: true });
          // Scroll to hero
          galleryEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // After 3s, scroll back to selected shade + progress + CTA
          window._qlv2ScrollBack = setTimeout(function () {
            window.removeEventListener('touchstart', onUserScroll);
            if (!userScrolled) {
              scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 3000);
        }
      }

      // Update swatch visual state
      shadeRadios.forEach(function (r) {
        var label = r.closest('.ac-swatch');
        if (label) label.classList.toggle('is-selected', r.checked);
      });
    }

    shadeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () { applyShade(radio); });
    });

    // ----- Swatch group collapse/expand
    var groupToggles = section.querySelectorAll('[data-ac-group-toggle]');
    groupToggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.ac-swatch-group');
        if (!group) return;
        var expanded = group.classList.toggle('ac-swatch-group--expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var more = btn.querySelector('[data-ac-group-toggle-more]');
        var less = btn.querySelector('[data-ac-group-toggle-less]');
        if (more) more.hidden = expanded;
        if (less) less.hidden = !expanded;
      });
    });

    function expandGroupForRadio(radio) {
      var group = radio.closest('.ac-swatch-group');
      if (!group || group.classList.contains('ac-swatch-group--expanded')) return;
      group.classList.add('ac-swatch-group--expanded');
      var btn = group.querySelector('[data-ac-group-toggle]');
      if (btn) {
        btn.setAttribute('aria-expanded', 'true');
        var more = btn.querySelector('[data-ac-group-toggle-more]');
        var less = btn.querySelector('[data-ac-group-toggle-less]');
        if (more) more.hidden = true;
        if (less) less.hidden = false;
      }
    }

    // ----- Initial state
    var initialChecked = section.querySelector('[data-ql-shade]:checked');
    if (initialChecked) {
      state.shadeName = initialChecked.getAttribute('data-shade-name') || '';
      if (variantInput) variantInput.value = initialChecked.value;
      var initPrice = parseInt(initialChecked.getAttribute('data-price-cents') || '', 10);
      if (!isNaN(initPrice) && initPrice > 0) state.unitCents = initPrice;
    }
    render();

    // ----- Bundle progress bar
    var ELIGIBLE_HANDLES = [
      '26-inch-pre-stretched-braiding-hair',
      '22-inch-pre-stretched-braiding-hair',
      '16-inch-pre-stretched-braiding-hair'
    ];
    var progressFill = section.querySelector('[data-qlv2-fill]');
    var progressMsg = section.querySelector('[data-qlv2-msg]');
    var progressMarkers = section.querySelectorAll('[data-qlv2-marker]');
    var prevTier = 0;

    var KIT_THRESHOLD = 7;
    var unitCentsForThreshold = state.unitCents || 1000;

    function updateProgressBar(count, animate) {
      if (!progressFill || !progressMsg) return;
      var pct = Math.min((count / KIT_THRESHOLD) * 100, 100);
      progressFill.style.width = pct + '%';

      // Update markers
      progressMarkers.forEach(function (m) {
        var val = parseInt(m.getAttribute('data-qlv2-marker'), 10);
        var hit = count >= val;
        m.classList.toggle('qlv2-progress__marker--hit', hit);
        if (animate && hit && !m.classList.contains('qlv2-progress__marker--pulsed')) {
          m.classList.add('qlv2-progress__marker--pulse');
          m.classList.add('qlv2-progress__marker--pulsed');
          setTimeout(function () { m.classList.remove('qlv2-progress__marker--pulse'); }, 700);
        }
      });

      var msg = '';
      var celebrate = false;
      var remaining = KIT_THRESHOLD - count;

      if (count >= KIT_THRESHOLD) {
        msg = '🎁 Complimentary Install Kit included';
        if (animate && prevTier < KIT_THRESHOLD) celebrate = true;
      } else if (count > 0) {
        msg = remaining + ' more pack' + (remaining > 1 ? 's' : '') + ' to unlock your free Install Kit 🎁';
      } else {
        msg = 'Add ' + KIT_THRESHOLD + ' packs to unlock your free Install Kit 🎁';
      }

      progressMsg.textContent = msg;
      progressMsg.classList.toggle('qlv2-progress__msg--celebrate', celebrate);
      if (celebrate) {
        setTimeout(function () {
          progressMsg.classList.remove('qlv2-progress__msg--celebrate');
        }, 2500);
      }

      prevTier = count;
    }

    function fetchCartAndUpdate(animate) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = 0;
          cart.items.forEach(function (item) {
            if (ELIGIBLE_HANDLES.indexOf(item.handle) !== -1) {
              count += item.quantity;
            }
          });
          updateProgressBar(count, animate);
        })
        .catch(function () {});
    }

    // Initial load
    fetchCartAndUpdate(false);

    // ----- Sticky bar visibility
    var ctaRow = section.querySelector('[data-ql-cta-wrap]');
    if (stickybar && ctaRow && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          stickybar.classList.toggle('ql-stickybar--visible', visible);
          stickybar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(ctaRow);
    }

    // ----- Sticky CTA → real form submit
    if (stickyCta && mainCta) {
      stickyCta.addEventListener('click', function (e) {
        e.preventDefault();
        if (mainCta.disabled) return;
        mainCta.click();
      });
    }

    // ----- Inline confirmation after add-to-cart (no drawer interruption)
    var productFormEl = section.querySelector('[data-js-product-form]');
    var addedEl = section.querySelector('[data-qlv2-added]');
    var addedTextEl = section.querySelector('[data-qlv2-added-text]');
    var addedTimeout = null;

    function getNudgeText(count) {
      if (count >= KIT_THRESHOLD) return '🎁 Complimentary Install Kit included';
      var remaining = KIT_THRESHOLD - count;
      return remaining + ' more pack' + (remaining > 1 ? 's' : '') + ' for your free Install Kit';
    }

    function showAddedConfirmation(shadeName, qty, cartCount) {
      if (!addedEl || !addedTextEl) return;
      var label = shadeName + (qty > 1 ? ' × ' + qty : '') + ' added!';
      var nudge = getNudgeText(cartCount);
      addedTextEl.textContent = label + ' · ' + nudge;
      addedEl.hidden = false;
      addedEl.classList.remove('qlv2-added--fade');
      if (addedTimeout) clearTimeout(addedTimeout);
      addedTimeout = setTimeout(function () {
        addedEl.classList.add('qlv2-added--fade');
        setTimeout(function () { addedEl.hidden = true; }, 300);
      }, 3000);
    }

    if (productFormEl) {
      productFormEl.addEventListener('add-to-cart', function () {
        var addedShade = state.shadeName || 'Item';
        var addedQty = state.qty;

        // Reset qty to 1 for next shade
        state.qty = 1;
        render();

        // Fetch cart, update progress bar, show confirmation with nudge
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var count = 0;
            cart.items.forEach(function (item) {
              if (ELIGIBLE_HANDLES.indexOf(item.handle) !== -1) {
                count += item.quantity;
              }
            });
            updateProgressBar(count, true);
            showAddedConfirmation(addedShade, addedQty, count);
          })
          .catch(function () {
            showAddedConfirmation(addedShade, addedQty, 0);
          });
      });
    }

    // ----- Gallery dot pagination
    var gallery = section.querySelector('.ql-gallery');
    var dots = section.querySelectorAll('.ql-gallery__dot');
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var index = Math.round(gallery.scrollLeft / gallery.offsetWidth);
        dots.forEach(function (dot, i) {
          dot.classList.toggle('ql-gallery__dot--active', i === index);
        });
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
